/* ============================================
   SUNFEEL Premium Eyewear - Shopify Theme JS
   FIEL ao site de demonstração original
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initScrollAnimations();
    initCookieBanner();
    initFloatingButtons();
    initMobileMenu();
    initSmoothScroll();
    initPageTransitions();
    initParallax();
    initTiltEffect();
    initCursorGlow();
    initLiquidGlassEffect();
    initMagneticButtons();
    initTextReveal();
    initCounterAnimation();
    initImageLazyLoading();
    initQuantitySelectors();
    initStaggerReveal();
    initAccordion();
    initTabs();
    initProductGallery();
    initCartFunctions();
    initProductFilters();
});

/* ============================================
   STICKY HEADER
   ============================================ */
function initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        if (currentScroll > 80) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
        if (currentScroll > lastScroll && currentScroll > 300) {
            header.style.transform = 'translateY(-100%)';
        } else {
            header.style.transform = 'translateY(0)';
        }
        lastScroll = currentScroll;
    });
}

/* ============================================
   SCROLL ANIMATIONS (IntersectionObserver)
   ============================================ */
function initScrollAnimations() {
    const elements = document.querySelectorAll('.animate-on-scroll');
    if (!elements.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    elements.forEach(el => observer.observe(el));
}

/* ============================================
   COOKIE BANNER (LGPD)
   ============================================ */
function initCookieBanner() {
    const banner = document.querySelector('.cookie-banner');
    if (!banner) return;
    const accepted = localStorage.getItem('sunfeel_cookies');
    if (!accepted) {
        setTimeout(() => banner.classList.add('visible'), 2000);
    }
    banner.querySelectorAll('.cookie-accept, .cookie-reject').forEach(btn => {
        btn.addEventListener('click', () => {
            localStorage.setItem('sunfeel_cookies', btn.classList.contains('cookie-accept') ? 'all' : 'essential');
            banner.classList.remove('visible');
        });
    });
}

/* ============================================
   FLOATING BUTTONS
   ============================================ */
function initFloatingButtons() {
    const topBtn = document.querySelector('.float-btn-top');
    if (!topBtn) return;
    window.addEventListener('scroll', () => {
        if (window.scrollY > 500) {
            topBtn.classList.add('visible');
        } else {
            topBtn.classList.remove('visible');
        }
    });
    topBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

/* ============================================
   MOBILE MENU
   ============================================ */
function initMobileMenu() {
    const toggle = document.querySelector('.mobile-toggle');
    const nav = document.querySelector('.main-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
        nav.classList.toggle('open');
        toggle.classList.toggle('active');
        document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
            nav.classList.remove('open');
            toggle.classList.remove('active');
            document.body.style.overflow = '';
        });
    });
}

/* ============================================
   SMOOTH SCROLL
   ============================================ */
function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
}

/* ============================================
   PAGE TRANSITIONS
   ============================================ */
function initPageTransitions() {
    const transition = document.querySelector('.page-transition');
    if (!transition) return;
    document.querySelectorAll('a[href]:not([href^="#"]):not([href^="mailto"]):not([href^="tel"]):not([target="_blank"])').forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && !href.startsWith('#') && !href.startsWith('javascript')) {
                e.preventDefault();
                transition.classList.add('active');
                setTimeout(() => { window.location.href = href; }, 600);
            }
        });
    });
}

/* ============================================
   PARALLAX
   ============================================ */
function initParallax() {
    const elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) return;
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        elements.forEach(el => {
            const speed = parseFloat(el.dataset.parallax) || 0.5;
            el.style.transform = `translateY(${scrollY * speed}px)`;
        });
    });
}

/* ============================================
   TILT 3D EFFECT
   ============================================ */
function initTiltEffect() {
    const cards = document.querySelectorAll('.glass-card, .product-card, .collection-card');
    cards.forEach(card => {
        card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const centerX = rect.width / 2;
            const centerY = rect.height / 2;
            const rotateX = (y - centerY) / centerY * -5;
            const rotateY = (x - centerX) / centerX * 5;
            card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px)`;
        });
        card.addEventListener('mouseleave', () => {
            card.style.transform = '';
        });
    });
}

/* ============================================
   CURSOR GLOW
   ============================================ */
function initCursorGlow() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const glow = document.createElement('div');
    glow.style.cssText = 'position:fixed;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(212,175,55,0.06) 0%,transparent 70%);pointer-events:none;z-index:9998;transform:translate(-50%,-50%);transition:opacity 0.3s;opacity:0;';
    document.body.appendChild(glow);
    document.addEventListener('mousemove', (e) => {
        glow.style.left = e.clientX + 'px';
        glow.style.top = e.clientY + 'px';
        glow.style.opacity = '1';
    });
    document.addEventListener('mouseleave', () => { glow.style.opacity = '0'; });
}

/* ============================================
   LIQUID GLASS EFFECT (on hover)
   ============================================ */
function initLiquidGlassEffect() {
    const glassCards = document.querySelectorAll('.glass-card');
    glassCards.forEach(card => {
        card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            card.style.background = `radial-gradient(circle at ${x}% ${y}%, rgba(212,175,55,0.1), rgba(255,255,255,0.6))`;
        });
        card.addEventListener('mouseleave', () => {
            card.style.background = '';
        });
    });
}

/* ============================================
   MAGNETIC BUTTONS
   ============================================ */
function initMagneticButtons() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const buttons = document.querySelectorAll('.btn-gold, .btn-outline');
    buttons.forEach(btn => {
        btn.addEventListener('mousemove', (e) => {
            const rect = btn.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;
            btn.style.transform = `translate(${x * 0.15}px, ${y * 0.15}px)`;
        });
        btn.addEventListener('mouseleave', () => {
            btn.style.transform = '';
        });
    });
}

/* ============================================
   TEXT REVEAL ANIMATION
   ============================================ */
function initTextReveal() {
    const headings = document.querySelectorAll('.section-header h2');
    headings.forEach(heading => {
        heading.style.clipPath = 'inset(0 100% 0 0)';
        heading.style.transition = 'clip-path 1s cubic-bezier(0.77, 0, 0.175, 1)';
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.clipPath = 'inset(0 0% 0 0)';
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });
        observer.observe(heading);
    });
}

/* ============================================
   COUNTER ANIMATION
   ============================================ */
function initCounterAnimation() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = parseInt(entry.target.dataset.count);
                const suffix = entry.target.dataset.suffix || '';
                let current = 0;
                const increment = target / 60;
                const timer = setInterval(() => {
                    current += increment;
                    if (current >= target) {
                        entry.target.textContent = target + suffix;
                        clearInterval(timer);
                    } else {
                        entry.target.textContent = Math.floor(current) + suffix;
                    }
                }, 16);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });
    counters.forEach(counter => observer.observe(counter));
}

/* ============================================
   IMAGE LAZY LOADING
   ============================================ */
function initImageLazyLoading() {
    const images = document.querySelectorAll('img[data-src]');
    if (!images.length) return;
    const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.add('loaded');
                imageObserver.unobserve(img);
            }
        });
    }, { rootMargin: '100px' });
    images.forEach(img => imageObserver.observe(img));
}

/* ============================================
   QUANTITY SELECTORS
   ============================================ */
function initQuantitySelectors() {
    document.querySelectorAll('.qty-control').forEach(control => {
        const minus = control.querySelector('.qty-minus');
        const plus = control.querySelector('.qty-plus');
        const input = control.querySelector('.qty-input');
        if (minus) {
            minus.addEventListener('click', () => {
                const val = parseInt(input.value) || 1;
                if (val > 1) {
                    input.value = val - 1;
                    input.dispatchEvent(new Event('change'));
                }
            });
        }
        if (plus) {
            plus.addEventListener('click', () => {
                const val = parseInt(input.value) || 1;
                input.value = val + 1;
                input.dispatchEvent(new Event('change'));
            });
        }
    });
}

/* ============================================
   STAGGER REVEAL
   ============================================ */
function initStaggerReveal() {
    const grids = document.querySelectorAll('.products-grid, .values-grid, .footer-grid, .collections-grid, .testimonials-grid, .features-grid, .about-values-grid');
    grids.forEach(grid => {
        const children = grid.children;
        Array.from(children).forEach((child, i) => {
            child.style.opacity = '0';
            child.style.transform = 'translateY(30px)';
            child.style.transition = `opacity 0.6s ease ${i * 0.1}s, transform 0.6s ease ${i * 0.1}s`;
        });
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    Array.from(entry.target.children).forEach(child => {
                        child.style.opacity = '1';
                        child.style.transform = 'translateY(0)';
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });
        observer.observe(grid);
    });
}

/* ============================================
   ACCORDION (FAQ)
   ============================================ */
function initAccordion() {
    document.querySelectorAll('.accordion-header').forEach(header => {
        header.addEventListener('click', () => {
            const item = header.parentElement;
            const content = item.querySelector('.accordion-content');
            const isActive = item.classList.contains('active');
            // Close all
            document.querySelectorAll('.accordion-item.active').forEach(activeItem => {
                activeItem.classList.remove('active');
                activeItem.querySelector('.accordion-content').style.maxHeight = '0';
            });
            // Toggle current
            if (!isActive) {
                item.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

/* ============================================
   TABS (Product page)
   ============================================ */
function initTabs() {
    document.querySelectorAll('.tab-button').forEach(button => {
        button.addEventListener('click', () => {
            const tabGroup = button.closest('.tabs-container') || button.closest('section') || document;
            const target = button.dataset.tab;
            tabGroup.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
            tabGroup.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            button.classList.add('active');
            const targetContent = tabGroup.querySelector(`[data-tab-content="${target}"]`) || document.getElementById(target);
            if (targetContent) targetContent.classList.add('active');
        });
    });
}

/* ============================================
   PRODUCT GALLERY
   ============================================ */
function initProductGallery() {
    const mainImage = document.querySelector('.product-gallery-main img');
    const thumbs = document.querySelectorAll('.product-gallery-thumbs img');
    if (!mainImage || !thumbs.length) return;
    thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
            mainImage.src = thumb.src;
            mainImage.alt = thumb.alt;
            thumbs.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        });
    });
}

/* ============================================
   CART FUNCTIONS
   ============================================ */
function initCartFunctions() {
    // Update cart count badge
    updateCartBadge();

    // Remove item buttons
    document.querySelectorAll('.cart-remove').forEach(btn => {
        btn.addEventListener('click', function() {
            const item = this.closest('.cart-item');
            if (item) {
                item.style.opacity = '0';
                item.style.transform = 'translateX(-100%)';
                setTimeout(() => item.remove(), 300);
            }
        });
    });

    // Add to cart buttons
    document.querySelectorAll('.add-to-cart').forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            this.textContent = 'Adicionado!';
            this.style.background = '#25D366';
            setTimeout(() => {
                this.textContent = this.dataset.originalText || 'Adicionar ao Carrinho';
                this.style.background = '';
            }, 2000);
        });
    });
}

function updateCartBadge() {
    const badges = document.querySelectorAll('.cart-count');
    const count = document.querySelectorAll('.cart-item').length;
    badges.forEach(badge => { badge.textContent = count; });
}

/* ============================================
   PRODUCT FILTERS
   ============================================ */
function initProductFilters() {
    const filters = document.querySelectorAll('.filter-option input');
    if (!filters.length) return;
    filters.forEach(filter => {
        filter.addEventListener('change', () => {
            const activeFilters = {};
            document.querySelectorAll('.filter-option input:checked').forEach(checked => {
                const group = checked.name || checked.dataset.group;
                if (!activeFilters[group]) activeFilters[group] = [];
                activeFilters[group].push(checked.value);
            });
            const products = document.querySelectorAll('.product-card[data-tags]');
            products.forEach(product => {
                const tags = product.dataset.tags ? product.dataset.tags.split(',') : [];
                let show = true;
                for (const group in activeFilters) {
                    if (activeFilters[group].length > 0) {
                        const match = activeFilters[group].some(val => tags.includes(val));
                        if (!match) { show = false; break; }
                    }
                }
                product.style.display = show ? '' : 'none';
            });
        });
    });
}
